/**
 * Shared React Query client instance — the ONE client for the whole app.
 *
 * `App.tsx` used to construct a second client and mount its own provider, which
 * shadowed this one for every component (see 9c681eef, which fixed the same bug
 * on the unmerged `paginated-reranking` branch). Do not reintroduce a second
 * `QueryClient` or `QueryClientProvider`; `src/lib/queryClient.test.ts` enforces
 * that there is exactly one of each.
 *
 * `staleTime` below is the app-wide DEFAULT. Every current query call site sets
 * its own `staleTime`, so this value governs only queries added in future — it
 * is intentionally a sensible floor rather than React Query's default of 0.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
